import React from 'react';
import heroVideo from '../assets/videos/hero.webm';
import logoWhite from '../assets/images/logos/VITAE GUITARS FINAL LOGO WHITE.png';

const HeroSection = () => {
  const navigateToBuilder = () => {
    window.location.href = '/builder';
  };

  const scrollToFeatured = () => {
    const featuredSection = document.getElementById('featured');
    if (featuredSection) {
      featuredSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToModels = () => {
    const modelsSection = document.getElementById('models');
    if (modelsSection) {
      modelsSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <video 
          autoPlay 
          loop 
          muted 
          playsInline
          className="w-full h-full object-cover object-center scale-105"
        >
          <source src={heroVideo} type="video/webm" />
          Your browser does not support the video tag.
        </video>
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-theme-bg-primary"></div>
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] opacity-20"></div>
      </div>
      
      <div className="container mx-auto px-6 z-10 relative">
        <div className="max-w-4xl mx-auto text-center">
          <div className="mb-8 opacity-0 animate-fadeInDown">
            <img 
              src={logoWhite} 
              alt="Vitæ Guitars Logo" 
              className="h-24 md:h-32 w-auto mx-auto drop-shadow-2xl"
            />
          </div>
          
          <h1 className="text-5xl md:text-7xl font-bold mb-6 text-white tracking-tight opacity-0 animate-fadeInUp animation-delay-300">
            <span className="block text-theme-primary-400 font-light tracking-[0.2em] text-2xl md:text-3xl mb-4 uppercase indent-[0.2em]">Beyond Tradition</span>
            Vit&aelig;&nbsp;Guitars
          </h1>

          <p className="text-xl md:text-2xl mb-10 text-gray-200 font-light leading-relaxed max-w-2xl mx-auto opacity-0 animate-fadeInUp animation-delay-600">
            Custom built guitars with a modern edge, inspired by iconic classic designs but made for the players of today. Shaped to sound, feel, and play like no other. It's more than a build - it's a shared obsession.
          </p>

          <div className="flex flex-col md:flex-row gap-6 justify-center items-center opacity-0 animate-fadeInUp animation-delay-900">
            <button
              onClick={navigateToBuilder}
              className="group relative w-full md:w-[280px] px-8 py-4 bg-theme-primary-500 text-white text-lg font-bold tracking-widest uppercase overflow-hidden rounded-button transition-all hover:bg-theme-primary-600 shadow-[0_0_20px_rgba(255,122,51,0.35)] hover:shadow-[0_0_30px_rgba(255,122,51,0.55)] whitespace-nowrap"
            >
              <span className="relative z-10">Start Your Build</span>
              <div className="absolute inset-0 h-full w-full scale-0 rounded-button transition-all duration-300 group-hover:scale-100 group-hover:bg-theme-primary-600/50"></div>
            </button>

            <button
              onClick={scrollToModels}
              className="w-full md:w-[280px] px-8 py-4 border border-white/30 text-white text-lg font-bold tracking-widest uppercase hover:bg-white/10 transition-all rounded-button backdrop-blur-sm whitespace-nowrap"
            >
              Explore Models
            </button>
          </div>
        </div>
      </div>
      
      <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 z-10 animate-bounce cursor-pointer" onClick={scrollToFeatured}>
        <i className="fas fa-chevron-down text-white/50 text-3xl hover:text-theme-primary-500 transition-colors"></i>
      </div>
    </section>
  );
};

export default HeroSection;
